// ** Kameralar
const initialFVV = {}

const hydrants = (state = initialFVV, action) => {
  switch (action.type) {
    case "SET_FVV_TYPES_CONTENT":
      return { ...action.val }
    default:
      return state
  }
}

export default hydrants
